// extracted by extract-css-chunks-webpack-plugin
module.exports = {"title":"title_qGCaK","providers":"providers_f1Rz-"};